import { z } from 'zod';

export const reservedCrewNumberSchema = z.object({
  product_id: z.string().uuid('Produit invalide'),
  crew_number_int: z
    .number()
    .int('Le numero doit etre entier')
    .positive('Le numero doit etre superieur a 0'),
  reason: z
    .string()
    .min(3, 'La raison doit contenir au moins 3 caracteres')
    .max(500, 'La raison est trop longue'),
});

export type ReservedCrewNumberInput = z.infer<typeof reservedCrewNumberSchema>;
